import React, { useContext } from 'react';

import { Actions, ActionsContext } from 'src/app/components/lib/actions';
import { MenuItem } from 'src/app/components/lib/menu-item';

import type { ButtonProps } from 'src/app/components/lib/button';

export type Action = {
  dataTestId?: string;
  disabled?: boolean;
  label: string;
  onClick: () => unknown;
  visible: boolean;
};

type ActionsMenuProps = {
  actions: Action[];
  buttonLabel?: string;
  buttonSize?: ButtonProps['buttonSize'];
  buttonVariant?: ButtonProps['variant'];
  buttonWidth?: string;
  className?: string;
};

function ActionsMenuItem({ action }: { action: Action }) {
  const actionsCtx = useContext(ActionsContext);

  function handleOnClick() {
    action.onClick();
    actionsCtx.handleClose();
  }

  const isDisabled = action.disabled ?? false;

  return (
    <MenuItem
      automationId={action.dataTestId}
      disabled={isDisabled}
      key={action.label}
      value={action.label}
      onClick={handleOnClick}
    >
      {action.label}
    </MenuItem>
  );
}

function ActionsMenu({ actions, buttonWidth, buttonLabel, buttonSize, buttonVariant, className }: ActionsMenuProps) {
  const visibleActions = actions.filter(({ visible }) => visible);

  if (!visibleActions.length) {
    return null;
  }

  return (
    <Actions
      buttonLabel={buttonLabel}
      buttonSize={buttonSize}
      buttonVariant={buttonVariant}
      buttonWidth={buttonWidth}
      className={className}
    >
      {visibleActions.map((action) => (
        <ActionsMenuItem action={action} key={action.label} />
      ))}
    </Actions>
  );
}

export default ActionsMenu;
